import { render, staticRenderFns } from "./BlockTitle.vue?vue&type=template&id=67a82edf"
import script from "./BlockTitle.vue?vue&type=script&lang=js"
export * from "./BlockTitle.vue?vue&type=script&lang=js"
import style0 from "./BlockTitle.vue?vue&type=style&index=0&id=67a82edf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports